import React, { useState } from "react";
import type { Company } from "newui/features/Company/types";
import { AccountSettings } from "./AccountSettings";

/* -------------------------------------------------------------------------- */
/* Types                                                                      */
/* -------------------------------------------------------------------------- */

interface SettingsProps {
  company: Company;
  path?: string;
}

/* -------------------------------------------------------------------------- */
/* Component                                                                  */
/* -------------------------------------------------------------------------- */

export const Settings: React.FC<SettingsProps> = ({ company }) => {
  const [activeSection, setActiveSection] = useState<'account'>('account');

  return (
    <div className="flex gap-6">
      <div className="flex-1 min-w-0">
        {activeSection === 'account' && <AccountSettings company={company} />}
      </div>
    </div>
  );
};
